import { Checkbox, FormControlLabel, Grid, TextField } from '@mui/material';
import { createRef } from 'react';
import NumberFormat from 'react-number-format';
import { connect } from 'react-redux';
import { RootState } from '../../../store';
type OwnProps = {
    handleNameChange: (val: string) => void;
    handleAmountChange: (val: number) => void;
    useBasePrice: boolean;
    handleUseBasePrice: (event: React.ChangeEvent<HTMLInputElement>) => void;
    name: string;
    amount: number;
};

const mapStateToProps = (state: RootState) => ({
    isEditCostDialogLoading: state.calculation.isEditCostDialogLoading
});

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const PercentageCostDialogContent = ({
    isEditCostDialogLoading,
    handleAmountChange,
    handleNameChange,
    useBasePrice,
    handleUseBasePrice,
    name,
    amount
}: Props) => {
    const amountInputRef = createRef();
    return (
        <div>
            <Grid container direction="column">
                <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    label="Name"
                    type="text"
                    fullWidth={true}
                    onChange={e => handleNameChange(e.target.value)}
                    value={name}
                    disabled={isEditCostDialogLoading}
                />
                <NumberFormat
                    getInputRef={amountInputRef}
                    customInput={TextField}
                    value={amount}
                    onValueChange={e => {
                        if (e.value === '') {
                            handleAmountChange(0);
                        }

                        if (e.floatValue != null) {
                            handleAmountChange(e.floatValue);
                        }
                    }}
                    decimalSeparator=","
                    thousandSeparator={false}
                    isNumericString={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    suffix=" %"
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={useBasePrice}
                            onChange={handleUseBasePrice}
                            name="useBasePrice"
                            color="primary"
                            disabled={isEditCostDialogLoading}
                        />
                    }
                    label="Calculate using baseprice"
                />
            </Grid>
        </div>
    );
};

export default connect(mapStateToProps)(PercentageCostDialogContent);
